import type { CommonData } from '@/components/blockEditor/blockEditor.types';
import { CURRENT_SCHEMA_VERSION } from '@/components/blockEditor/blockEditor.types';

export function getDefaultWhyUseTrustData(): CommonData {
  return {
    version: CURRENT_SCHEMA_VERSION,
    blocks: [
      {
        id: 'intro',
        type: 'ListItemsSection',
        props: {},
        children: {
          default: [
            {
              id: 'why-use-trust-heading',
              type: 'EducationalSlideHeading',
              props: {
                title:
                  'Trusts are powerful estate planning tools that offer more benefits than just asset transfer',
                variant: 'h4',
              },
            },
            {
              id: 'why-use-trust-intro',
              type: 'EditableEducationalSlideBody',
              props: {
                text: 'Trusts provide **control, protection and efficiency** during life and after death',
              },
            },
          ],
        },
      },
      {
        id: 'benefits',
        type: 'ListItemsSection',
        props: {},
        children: {
          default: [
            {
              id: 'why-use-trust-list',
              type: 'ListItemsSection',
              props: {},
              children: {
                default: [
                  {
                    id: 'item-probate',
                    type: 'PresentationListItem',
                    props: {
                      title: 'Avoid probate',
                      description:
                        'Assets held in a trust pass directly to beneficiaries without going through the court system, saving time, cost, and public exposure',
                      iconType: 'check',
                      iconColor: 'PRIMARY',
                    },
                  },
                  {
                    id: 'item-privacy',
                    type: 'PresentationListItem',
                    props: {
                      title: 'Maintain privacy',
                      description:
                        'Unlike wills, trusts are not public documents, allowing for discrete handling of your estate',
                      iconType: 'check',
                      iconColor: 'PRIMARY',
                    },
                  },
                  {
                    id: 'item-control',
                    type: 'PresentationListItem',
                    props: {
                      title: 'Control distributions',
                      description:
                        'Set specific rules for how and when beneficiaries receive assets — all at once, over time, or upon reaching certain milestones',
                      iconType: 'check',
                      iconColor: 'PRIMARY',
                    },
                  },
                  {
                    id: 'item-protect',
                    type: 'PresentationListItem',
                    props: {
                      title: 'Protect beneficiaries',
                      description:
                        'Trusts can safeguard assets from creditors or lawsuits, divorce claims, and poor financial management',
                      iconType: 'check',
                      iconColor: 'PRIMARY',
                    },
                  },
                  {
                    id: 'item-tax',
                    type: 'PresentationListItem',
                    props: {
                      title: 'Potential tax savings',
                      description:
                        'Certain irrevocable trusts can reduce estate, gift, or income taxes when structured properly',
                      iconType: 'check',
                      iconColor: 'PRIMARY',
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    ],
  };
}
